import {
  Datagrid,
  DateField,
  DeleteWithConfirmButton,
  List,
  TextField
} from "react-admin";

// const Aside = () => (
//   <div style={{ width: 200, margin: "1em" }}>
//     <h3>123</h3>
//   </div>
// );

export const StoryList = (props) => {
  return (
    <List
      {...props}
      // aside={<Aside />}
    >
      <Datagrid rowClick="show">
        <TextField source="description" />
        <DateField source="startTimestamp" label="Start Time" locales="en-IN" />
        <DateField source="endTimestamp" label="End Time" locales="en-IN" />
        <DeleteWithConfirmButton />
      </Datagrid>
    </List>
  );
};
